import React, { Component } from "react";
import { Icon } from "react-materialize";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";

import EventUtils from "../../utils/EventUtils";

import "./NavBar.css";

class NavBar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showAddToCart: false,
      currentView: "",
    };

    this.handleSubmissionViewClick = this.handleSubmissionViewClick.bind(this);
    this.handleAssetViewClick = this.handleAssetViewClick.bind(this);
  }

  async handleSubmissionViewClick(event) {
    this.setState({ currentView: "submissionview" }, () =>
      EventUtils.raiseEvent(
        "close-cart",
        { view: this.state.currentView },
        this.props
      )
    );
  }

  async handleAssetViewClick(event) {
    this.setState({ currentView: "assetview" }, () =>
      EventUtils.raiseEvent(
        "close-cart",
        { view: this.state.currentView },
        this.props
      )
    );
  }

  render() {
    const hrefLink = "#";
    const { pathname } = this.props.location;
    const { cartActive, cartItemsCount } = this.props;

    return (
      <nav className="nav-bar">
        <ul>
          {/* <li className={ pathname.startsWith(SubmissionsView.getPath()) ? 'nav-item active' : 'nav-item' } onClick={this.handleSubmissionViewClick}>
                        <Link to={ SubmissionsView.getPath() }>
                            <Icon small>find_in_page</Icon>
                            <div className="nav-text">Submission Search</div>
                        </Link>
                    </li> */}
          <li
            className={
              pathname.startsWith("/Audit") ? "nav-item active" : "nav-item"
            }
            onClick={
              this.handleAssetViewClick // className="nav-item active"
            }>
            <Link to="/AuditReport/">
              <Icon small>pie_chart</Icon>
              <div className="nav-text">Audit Report</div>
            </Link>
          </li>
          <li className={cartActive ? "nav-item active" : "nav-item"}>
            <a
              href={hrefLink}
              onClick={() =>
                EventUtils.raiseEvent("show-cart-click", null, this.props)
              }>
              <Icon small>shopping_cart</Icon>
              <div className="nav-text">Cart</div>
              <span className="cart-badge" hidden={!cartItemsCount}>
                {cartItemsCount}
              </span>
            </a>
          </li>
        </ul>
      </nav>
    );
  }
}

export default withRouter(NavBar);
